var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333132",
    fillRule: "evenodd",
    d: "M22.145 12.38a.5.5 0 0 1 .5.5v6.063a2.21 2.21 0 0 1-2.201 2.202l-16.89-.001A2.2 2.2 0 0 1 2 20.499c0-.02-.645-.566-.645-1.556V12.88a.5.5 0 0 1 .5-.5h.843a.5.5 0 0 1 .5.5v6.064c0 .1.04.19.104.254l.002-.002a.36.36 0 0 0 .253.106h16.889c.2 0 .358-.157.358-.358V12.88a.5.5 0 0 1 .5-.5zm-5.48-.88-1.302-1.304-2.442 2.443V2.856H11.08v9.783l-2.443-2.443L7.333 11.5l4.015 4.016c.36.36.943.36 1.303 0z",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;